/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Button, OverlayTrigger, Dropdown, Tooltip } from 'react-bootstrap';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import Dialog from '@material-ui/core/Dialog';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import DialogActions from '@material-ui/core/DialogActions';
import CopyContact from '../../../../SharedModules/Contact/copyContact';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import cancelIcon from '../../../../assets/images/Icon-cancel.png';
import {
  getExistingContactDetails,
  getContactDetails,
  saveContactData,
  setIsValidContactForm,
  getAllContactType,
} from '../store/actions';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  formatPhoneNumber,
  handleExistingCommentList,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';
import TooltipTextField from '../../../../SharedModules/Tooltip/TooltipTextField';
import { PaperComponent } from '../../../../SharedModules/utilities/utilities';
import { EMAIL_ID_REGEX } from '../../../../SharedModules/AppConstants';
import { keyframes } from '@emotion/react';

/** True when code exists on current Contact Type dropdown (case-insensitive). */
const isContactTypeInDropdown = (contactTypeCd, dropDown) => {
  if (!contactTypeCd || contactTypeCd === '-1') return false;
  const list = dropDown || [];
  return list.some(
    (item) =>
      item?.contactTypeCd &&
      String(item.contactTypeCd).toLowerCase() ===
        String(contactTypeCd).toLowerCase()
  );
};

// Editable contact fields only — contactTypeCd is browse/view and not a saveable change.
const CONTACT_COMPARE_FIELDS = [
  'contactName',
  'corpName',
  'addrLine1',
  'addrLine2',
  'addrLine3',
  'city',
  'stateCd',
  'zip',
  'zip4',
  'phoneNum',
  'phoneExtension',
  'faxNum',
  'email',
];

const normalizeContactField = (value) => {
  if (value === null || value === undefined) return '';
  return typeof value === 'string' ? value.trim() : String(value);
};

const getComparableContact = (contact = {}) => {
  return CONTACT_COMPARE_FIELDS.reduce((acc, field) => {
    acc[field] = normalizeContactField(contact[field]);
    return acc;
  }, {});
};

const isContactFormUnchanged = (current, original) => {
  if (!original) return false;
  const curr = getComparableContact(current);
  return CONTACT_COMPARE_FIELDS.every(
    (field) => curr[field] === original[field]
  );
};

export const intializeContactData = {
  contactTypeCd: '-1',
  contactSeqNum: null,
  key: '',
  keyTypeCd: 'CGP',
  contactName: '',
  corpName: '',
  addrLine1: '',
  addrLine2: '',
  addrLine3: '',
  city: '',
  stateCd: '',
  zip: '',
  zip4: '',
  phoneNum: '',
  phoneExtension: '',
  faxNum: '',
  email: '',
  corrLinkId: null,
};

const PlanContactForm = (props) => {
  const {
    keyTypeCd,
    keyId,
    setIsFormChanged,
    entityType,
    defaultValues,
    setContactErrors,
    setSuccessMessage,
    disableFields,
    setErrorMessages,
    contactType,
    onContactDirtyChange,
    contactFormDirty: contactFormDirtyProp,
    savePopup,
  } = props;
  const dispatch = useDispatch();
  const getExistingContactDetailsValue = (value, type) =>
    dispatch(getExistingContactDetails(value, type));
  const getContactDetailsValue = (value, type) =>
    dispatch(getContactDetails(value, type));
  const cgpId = useSelector((state) => {
    return state.sharedState.PlanReducer.plansByCgp &&
      state.sharedState.PlanReducer.plansByCgp.length &&
      state.sharedState.PlanReducer.plansByCgp.length > 0 &&
      state.sharedState.PlanReducer.plansByCgp[0].cgpId
      ? state.sharedState.PlanReducer.plansByCgp[0].cgpId
      : {
          clientId: '',
          groupId: '',
          planId: '',
        };
  });
  const [ccCommentsExist, setCcCommentsExist] = useState(0);
  const [defaultPlanContactData, setDefaultPlanContactData] = useState([]);
  const [showComments, setShowComments] = useState(false);

  const contactTypeDropDown = useSelector((state) => {
    if (keyTypeCd === 'CLIENT') {
      return state.sharedState.PlanReducer?.allContactTypeDropDownClient;
    }
    if (keyTypeCd === 'CGP') {
      return state.sharedState.PlanReducer?.allContactTypeDropDownPlan;
    }
    if (keyTypeCd === 'CG') {
      return state.sharedState.PlanReducer?.allContactTypeDropDownGroup;
    }
    if (keyTypeCd === 'TYPEPROV') {
      return state.sharedState.PlanReducer?.allContactTypeDropDownProvider;
    }
  });
  const existingContactDetails = useSelector((state) => {
    if (keyTypeCd === 'CLIENT') {
      return state.sharedState.PlanReducer?.existingContactDetailsClient;
    }
    if (keyTypeCd === 'CGP') {
      return state.sharedState.PlanReducer?.existingContactDetailsPlan;
    }
    if (keyTypeCd === 'CG') {
      return state.sharedState.PlanReducer?.existingContactDetailsGroup;
    }
    if (keyTypeCd === 'TYPEPROV') {
      return state.sharedState.PlanReducer?.existingContactDetailsProvider;
    }
  });
  const contactDetails = useSelector((state) => {
    if (keyTypeCd === 'CLIENT') {
      return state.sharedState.PlanReducer?.contactDetailsClient;
    }
    if (keyTypeCd === 'CGP') {
      return state.sharedState.PlanReducer?.contactDetailsPlan;
    }
    if (keyTypeCd === 'CG') {
      return state.sharedState.PlanReducer?.contactDetailsGroup;
    }
    if (keyTypeCd === 'TYPEPROV') {
      return state.sharedState.PlanReducer?.contactDetailsProvider;
    }
  });
  const allContactData = useSelector((state) => {
    return state.sharedState.PlanReducer.allContactData;
  });
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer?.CommentListData;
  });
  const [contactValues, setContactValues] = useState({
    addrLine1: '',
    addrLine2: '',
    addrLine3: '',
    city: '',
    contactName: '',
    contactSeqNum: '',
    contactTypeCd: '',
    corpName: '',
    faxNum: '',
    key: '',
    keyTypeCd: '',
    phoneExtension: '',
    phoneNum: '',
    stateCd: '',
    zip: '',
    zip4: '',
  });

  const [
    {
      showNameErr,
      showAddrErr,
      showCityErr,
      showStateErr,
      showZipErr,
      showPhoneErr,
      showFaxErr,
      showEmailErr,
      showContacttypeErr,
    },
    setShowError,
  ] = useState({});

  useEffect(() => {
    if (defaultValues) {
      const defaultPlanContactArr = [];
      const defaultPlanContactObj = {};
      if (keyTypeCd === 'CG' && defaultValues?.groupId) {
        defaultPlanContactObj.keyTypeCd = keyTypeCd;
        defaultPlanContactObj.groupId = keyId;
        defaultPlanContactObj.groupName = defaultValues?.groupName;
      } else if (keyTypeCd === 'CGP' && defaultValues?.planId) {
        defaultPlanContactObj.keyTypeCd = keyTypeCd;
        defaultPlanContactObj.cgpId = keyId;
        defaultPlanContactObj.planName = defaultValues?.planName;
        defaultPlanContactObj.planId = defaultValues?.planId;
      } else if (keyTypeCd === 'CLIENT' && defaultValues?.clientId) {
        defaultPlanContactObj.keyTypeCd = keyTypeCd;
        defaultPlanContactObj.clientId = keyId;
        defaultPlanContactObj.clientName = defaultValues?.clientName;
      } else if (keyTypeCd === 'CONTRACT' && defaultValues?.contractNum) {
        defaultPlanContactObj.keyTypeCd = keyTypeCd;
        defaultPlanContactObj.contractNum = keyId;
        defaultPlanContactObj.contractName = defaultValues?.contractName;
      } else if (keyTypeCd === 'MFG' && defaultValues?.mfgId) {
        defaultPlanContactObj.keyTypeCd = keyTypeCd;
        defaultPlanContactObj.mfgId = keyId;
        defaultPlanContactObj.mfgName = defaultValues?.mfgName;
      }
      defaultPlanContactArr.push(defaultPlanContactObj);
      setDefaultPlanContactData(defaultPlanContactArr);
    }
  }, [defaultValues]);

  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);

  const [values, setValues] = useState({
    addrLine1: '',
    addrLine2: '',
    addrLine3: '',
    city: '',
    contactName: '',
    contactSeqNum: '',
    contactTypeCd: '-1',
    corpName: '',
    faxNum: '',
    key: '',
    keyTypeCd: '',
    phoneExtension: '',
    phoneNum: '',
    stateCd: '',
    zip: '',
    zip4: '',
  });

  const hasHydratedFromExistingContactsRef = React.useRef(false);
  const originalContactRef = React.useRef(null);
  const originalContactSnapshotRef = React.useRef(null);
  const userEditedContactRef = React.useRef(false);
  const contactTypeBrowseRef = React.useRef(false);
  const isRestoringContactRef = React.useRef(false);
  const saveInProgressRef = React.useRef(false);
  const prevContactFormDirtyRef = React.useRef(contactFormDirtyProp);
  const valuesRef = React.useRef(values);
  valuesRef.current = values;
  const allContactDataRef = React.useRef(allContactData);
  allContactDataRef.current = allContactData;

  const cloneContact = (contact) => JSON.parse(JSON.stringify(contact || {}));

  const isBlankContact = (contact) => {
    if (!contact || _.isEqual(contact, {})) return true;
    return (
      (!contact.contactTypeCd ||
        contact.contactTypeCd === '-1' ||
        contact.contactTypeCd === '') &&
      !contact.contactName &&
      !contact.addrLine1 &&
      !contact.city &&
      !contact.email &&
      (contact.corrLinkId === null || contact.corrLinkId === undefined)
    );
  };

  const setOriginalContactBaseline = (contact, force = false) => {
    originalContactRef.current = getComparableContact(contact);
    if (force || !userEditedContactRef.current) {
      originalContactSnapshotRef.current = cloneContact(contact);
    }
  };

  const notifyContactDirty = (dirty) => {
    userEditedContactRef.current = dirty;
    if (typeof onContactDirtyChange === 'function') {
      // Parent owns Save enable via contactFormDirty — do not touch other-tab dirty flag.
      onContactDirtyChange(dirty);
    } else if (dirty && typeof setIsFormChanged === 'function') {
      // Legacy fallback when parent has not wired onContactDirtyChange.
      setIsFormChanged(false);
    }
  };

  const restoreOriginalContact = () => {
    const snapshot = originalContactSnapshotRef.current;
    if (!snapshot) return;
    const restored = cloneContact(snapshot);
    isRestoringContactRef.current = true;
    setValues(restored);
    setContactValues(restored);
    dispatch(saveContactData(restored));
    setShowError({});
    if (setContactErrors) setContactErrors([]);
    userEditedContactRef.current = false;
    contactTypeBrowseRef.current = false;
    notifyContactDirty(false);
    if (restored?.corrLinkId) {
      handleExistingCommentList([{ corrLinkId: restored.corrLinkId }]).then(
        (res) => {
          setCcCommentsExist(res?.ccCommentsExist || 0);
        }
      );
    } else {
      setCcCommentsExist(0);
    }
  };

  const syncContactDirtyWithParent = (updatedContact) => {
    const unchanged = isContactFormUnchanged(
      updatedContact,
      originalContactRef.current
    );
    notifyContactDirty(!unchanged);
    return unchanged;
  };

  React.useEffect(() => {
    hasHydratedFromExistingContactsRef.current = false;
    originalContactRef.current = null;
    originalContactSnapshotRef.current = null;
    userEditedContactRef.current = false;
    contactTypeBrowseRef.current = false;
    notifyContactDirty(false);
  }, [keyId, keyTypeCd]);

  // Restore the loaded contact on Cancel. Skip when Save is in progress so
  // saved values stay and become the new baseline.
  React.useEffect(() => {
    if (savePopup) {
      saveInProgressRef.current = true;
    }
    const wasDirty = prevContactFormDirtyRef.current;
    prevContactFormDirtyRef.current = contactFormDirtyProp;
    if (contactFormDirtyProp === false) {
      userEditedContactRef.current = false;
    }
    if (wasDirty && contactFormDirtyProp === false) {
      const currentValues = valuesRef.current;
      const currentRedux = allContactDataRef.current;
      const saving = savePopup || saveInProgressRef.current;
      const reduxMatchesForm =
        !isBlankContact(currentRedux) &&
        isContactFormUnchanged(
          currentValues,
          getComparableContact(currentRedux)
        );
      if (saving || reduxMatchesForm) {
        setOriginalContactBaseline(currentValues, true);
      } else if (originalContactSnapshotRef.current) {
        restoreOriginalContact();
      }
      saveInProgressRef.current = false;
    }
    if (!savePopup) {
      saveInProgressRef.current = false;
    }
  }, [contactFormDirtyProp, savePopup]);

  useEffect(() => {
    if (defaultValues) {
      const defaultPlanContactArr = [];
      const defaultPlanContactObj = {};
      if (keyTypeCd === 'CG' && defaultValues?.groupId) {
        defaultPlanContactObj.keyTypeCd = keyTypeCd;
        defaultPlanContactObj.groupId = defaultValues?.groupId;
        defaultPlanContactObj.groupName = defaultValues?.groupName;
      } else if (keyTypeCd === 'CGP' && defaultValues?.planId) {
        defaultPlanContactObj.keyTypeCd = keyTypeCd;
        defaultPlanContactObj.cgpId = keyId;
        defaultPlanContactObj.planName = defaultValues?.planName;
        defaultPlanContactObj.planId = defaultValues?.planId;
      } else if (keyTypeCd === 'CLIENT' && defaultValues?.clientId) {
        defaultPlanContactObj.keyTypeCd = keyTypeCd;
        defaultPlanContactObj.clientId = keyId;
        defaultPlanContactObj.clientName = defaultValues?.clientName;
      } else if (keyTypeCd === 'CONTRACT' && defaultValues?.contractNum) {
        defaultPlanContactObj.keyTypeCd = keyTypeCd;
        defaultPlanContactObj.contractNum = keyId;
        defaultPlanContactObj.contractName = defaultValues?.contractName;
      } else if (keyTypeCd === 'MFG' && defaultValues?.mfgId) {
        defaultPlanContactObj.keyTypeCd = keyTypeCd;
        defaultPlanContactObj.mfgId = keyId;
        defaultPlanContactObj.mfgName = defaultValues?.mfgName;
      } else if (
        keyTypeCd === 'TYPEPROV' &&
        defaultValues?.providerPK?.providerId
      ) {
        defaultPlanContactObj.keyTypeCd = keyTypeCd;
        defaultPlanContactObj.providedID =
          defaultValues?.providerPK?.providerId;
        defaultPlanContactObj.providerTypeCDAndId = keyId;
        defaultPlanContactObj.name = defaultValues?.name;
      }
      defaultPlanContactArr.push(defaultPlanContactObj);
    }
  }, [defaultValues]);
  // React.useEffect(() => {
  //   if (
  //     (values?.contactTypeCd === '-1' || values?.contactTypeCd === '') &&
  //     contactTypeDropDown?.length > 0
  //   ) {
  //     setValues({
  //       ...values,
  //       contactTypeCd: contactTypeDropDown?.[0].contactTypeCd,
  //     });
  //   }
  // }, [contactTypeDropDown?.length > 0]);
  const isNameDisabled = values.contactTypeCd === 'PROV1' || !isEnablebyRole
  const isValidContactForm = () => {
    // Contact Type browse-only / never edited — do not block save or show field errors.
    if (!userEditedContactRef.current) {
      setShowError({});
      if (setContactErrors) setContactErrors([]);
      dispatch(setIsValidContactForm(true));
      return true;
    }
    // Disabled/read-only contact fields — skip required field validation.
    if (disableFields || values.contactTypeCd === 'PROV1') {
      setShowError({});
      if (setContactErrors) setContactErrors([]);
      dispatch(setIsValidContactForm(true));
      return true;
    }
    const errorMessageArray = [];
    let showContacttypeErr = false;
    let showNameEr = false;
    let showAddrEr = false;
    let showCityEr = false;
    let showStateEr = false;
    let showZipEr = false;
    let showPhoneEr = false;
    let showFaxErr = false
    let showEmailEr = false;
    let isValid = false;
    if (
      !contactValues.contactTypeCd ||
      contactValues.contactTypeCd === '-1' ||
      (contactTypeDropDown?.length > 0 &&
        !isContactTypeInDropdown(
          contactValues.contactTypeCd,
          contactTypeDropDown
        ))
    ) {
      errorMessageArray.push(constantMessageData.CONTACT_TYPE_REQUIRED);
      showContacttypeErr = true;
    }
    const skipContactValidation = disableFields || values.contactTypeCd === 'PROV1';
    if (!skipContactValidation && !contactValues.contactName) {
      errorMessageArray.push(constantMessageData.NAME_REQUIRED);
      showNameEr = true;
    }
    
    if (!skipContactValidation && !contactValues.addrLine1) {
      errorMessageArray.push(constantMessageData.ADDRESS_LINE1_REQUIRED);
      showAddrEr = true;
    }
    
    if (!skipContactValidation && !contactValues.city) {
      errorMessageArray.push(constantMessageData.CITY_REQUIRED);
      showCityEr = true;
    }
   
    if (!skipContactValidation &&!contactValues.stateCd) {
      errorMessageArray.push(constantMessageData.STATE_REQUIRED);
      showStateEr = true;
    }
    if (!skipContactValidation &&!contactValues.zip) {
      errorMessageArray.push(constantMessageData.ZIP_REQUIRED);
      showZipEr = true;
    }
    if (!skipContactValidation &&!contactValues.phoneNum) {
      errorMessageArray.push(constantMessageData.PHONE_REQUIRED);
      showPhoneEr = true;
    }
    if (
      contactValues.faxNum &&
      contactValues.faxNum.replace(/[^0-9]/g, '').length !== 10
    ) {
      errorMessageArray.push('Fax number must be 10 digits.');
      showFaxErr = true;
    }
    if (contactValues.email && !EMAIL_ID_REGEX.test(contactValues.email)) {
      errorMessageArray.push(constantMessageData.EMAIL_INVALID);
      showEmailEr = true;
    }

    setShowError({
      showNameErr: showNameEr,
      showAddrErr: showAddrEr,
      showCityErr: showCityEr,
      showStateErr: showStateEr,
      showZipErr: showZipEr,
      showPhoneErr: showPhoneEr,
      showFaxErr: showFaxErr,
      showEmailErr: showEmailEr,
      showContacttypeErr,
    });
    if (errorMessageArray.length > 0) {
      setContactErrors(errorMessageArray);
      isValid = false;
    } else {
      setContactErrors([]);
      isValid = true;
    }
    dispatch(setIsValidContactForm(isValid));
    return isValid;
  };

  const keyType = cgpId.clientId + cgpId.groupId + cgpId.planId;

  const handleOnChangeEvent = (e, name) => {
    if (setErrorMessages) setErrorMessages([]);
    setSuccessMessage([]);
   
    let formattedPhn = '';
    let updatedValues = {
      ...values,
      key: keyId,
      keyTypeCd: keyTypeCd || 'CGP',
    };
   
    if (name === 'contactTypeCd') {
      // Browse existing contacts — do not mark form dirty / enable Save.
      contactTypeBrowseRef.current = true;
      getContactDetailsValue(
        {
          keyTypeCd: keyTypeCd || 'CGP',
          key: keyId?.trim(),
          contactTypeCd: e.target.value,
        },
        keyTypeCd === 'CLIENT'
          ? 'client'
          : keyTypeCd === 'CG'
          ? 'group'
          : keyTypeCd === 'TYPEPROV'
          ? 'provider'
          : 'plan'
      );
      updatedValues[name] = e.target.value;
      setValues(updatedValues);
      if (setContactValues) {
        setContactValues(updatedValues);
        dispatch(saveContactData(updatedValues));
      }
      return;
    } else if (
      name === 'phoneNum' ||
      name === 'zip' ||
      name === 'zip4' ||
      name === 'faxNum' ||
      name === 'phoneExtension'
    ) {
      if (name === 'phoneNum') {
        formattedPhn = formatPhoneNumber(e);
        updatedValues[name] = formattedPhn;
      } else {
        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
        updatedValues[name] = onlyNums;
      }
    } else {
      updatedValues[name] = e.target.value;
    }
   
    setValues(updatedValues);
    if (setContactValues) {
      setContactValues(updatedValues);
      dispatch(saveContactData(updatedValues));
    }
    syncContactDirtyWithParent(updatedValues);
  };
  const [open, setOpen] = useState(false);

  const [selectedContact, setSelectedContact] = useState(null);
  const intializeContactReset = {
    ...intializeContactData,
    key: keyId,
    keyTypeCd: keyTypeCd || 'CGP',
  };

  React.useEffect(() => {
    if (contactDetails?.length > 0) {
      const newContactData = {
        ...contactDetails[0],
      };
      const safeContactTypeCd = !contactTypeDropDown?.length
        ? newContactData.contactTypeCd || '-1'
        : isContactTypeInDropdown(
            newContactData.contactTypeCd,
            contactTypeDropDown
          )
        ? newContactData.contactTypeCd
        : '-1';
      const hydratedValues = {
        contactTypeCd: safeContactTypeCd || '-1',
        contactSeqNum: newContactData.contactSeqNum,
        key: newContactData.key,
        keyTypeCd: newContactData.keyTypeCd || 'CGP',
        contactName: newContactData.contactName || '',
        corpName: newContactData.corpName || '',
        addrLine1: newContactData.addrLine1 || '',
        addrLine2: newContactData.addrLine2 || '',
        addrLine3: newContactData.addrLine3 || '',
        city: newContactData.city || '',
        stateCd: newContactData.stateCd || '',
        zip: newContactData.zip || '',
        zip4: newContactData.zip4 || '',
        phoneNum: newContactData.phoneNum || '',
        phoneExtension: newContactData.phoneExtension || '',
        faxNum: newContactData.faxNum || '',
        email: newContactData.email || '',
        corrLinkId: newContactData.corrLinkId ?? null,
      };
      setValues(hydratedValues);
      const mergedContact = {
        ...newContactData,
        contactTypeCd: safeContactTypeCd || '-1',
        corrLinkId: newContactData.corrLinkId ?? null,
      };
      if (setContactValues) {
        setContactValues(mergedContact);
      }
      dispatch(saveContactData(mergedContact));
      if (contactTypeBrowseRef.current || !userEditedContactRef.current) {
        setOriginalContactBaseline(hydratedValues);
        contactTypeBrowseRef.current = false;
        notifyContactDirty(false);
      }
      if (mergedContact?.corrLinkId) {
        handleExistingCommentList([
          { corrLinkId: mergedContact?.corrLinkId },
        ]).then((res) => {
          setCcCommentsExist(res.ccCommentsExist);
        });
      }
    } else if (contactDetails?.length === 0) {
      intializeContactReset.contactTypeCd = values?.contactTypeCd;
      intializeContactReset.corrLinkId = null;
      setValues(intializeContactReset);
      setContactValues(intializeContactReset);
      dispatch(saveContactData(intializeContactReset));
      setCcCommentsExist(0);
      if (contactTypeBrowseRef.current || !userEditedContactRef.current) {
        setOriginalContactBaseline(intializeContactReset);
        contactTypeBrowseRef.current = false;
        notifyContactDirty(false);
      }
    }
  }, [contactDetails]);
  React.useEffect(() => {
    if (!showComments) {
      return;
    }
    const contactCorrLinkId =
      values?.corrLinkId || allContactData?.corrLinkId;
    // Icon reflects this contact's comments only — not leftover/system lists.
    if (!contactCorrLinkId || contactCorrLinkId === -1) {
      setCcCommentsExist(0);
      return;
    }
    setCcCommentsExist(commentsList?.length > 0 ? 1 : 0);
  }, [commentsList, showComments]);

  useEffect(() => {
    if (isRestoringContactRef.current) {
      isRestoringContactRef.current = false;
      return;
    }
    if (!allContactData || _.isEqual(allContactData, {})) {
      intializeContactReset.contactTypeCd = values?.contactTypeCd;
      const newValue = JSON.parse(JSON.stringify(intializeContactReset));
      setValues(newValue);
      setContactValues(newValue);
      return;
    }
    if (
      isBlankContact(allContactData) &&
      originalContactSnapshotRef.current &&
      !isBlankContact(originalContactSnapshotRef.current)
    ) {
      restoreOriginalContact();
      return;
    }
    setValues(allContactData);
    setContactValues(allContactData);
    if (!userEditedContactRef.current && !isBlankContact(allContactData)) {
      setOriginalContactBaseline(allContactData);
    }
  }, [allContactData]);

  useEffect(() => {
    isValidContactForm();
    // Re-validate when contact data or the type dropdown changes (not only after a field edit),
    // so save is blocked until mandatory contact fields are complete.
  }, [contactValues, contactTypeDropDown]);

  const setContactIfNotEmpty = () => {
    if (selectedContact) {
      selectedContact.contactTypeCd = values?.contactTypeCd;
      selectedContact.key = keyId?.trim();
      selectedContact.keyTypeCd = keyTypeCd || 'CGP';
      if (selectedContact?.corrLinkId) delete selectedContact?.corrLinkId;
      selectedContact.contactSeqNum = values.contactSeqNum;
      setValues(selectedContact);
      // Copy Contact is a real edit — enable Save via dirty callback.
      notifyContactDirty(true);
      if (setContactValues) {
        setContactValues(selectedContact);
        dispatch(saveContactData(selectedContact));
      }
      setSelectedContact(null);
    }
    handleClose();
  };

  const handleOpen = () => {
    if (values.contactTypeCd === 'PROV1') {
      setErrorMessages([constantMessageData.OVERWRITE_CONTACT_FRM_FILE]);
    } else {
      setOpen(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  React.useEffect(() => {
    if (!contactTypeDropDown?.length > 0) {
      dispatch(
        getAllContactType(
          { keyTypeCd: keyTypeCd || 'CGP' },
          keyTypeCd === 'CLIENT'
            ? 'client'
            : keyTypeCd === 'CG'
            ? 'group'
            : keyTypeCd === 'TYPEPROV'
            ? 'provider'
            : 'plan'
        )
      );
    }
    if (!existingContactDetails?.length > 0) {
      getExistingContactDetailsValue(
        {
          key: [keyId?.trim()],
          keyTypeCd: keyTypeCd || 'CGP',
        },
        keyTypeCd === 'CLIENT'
          ? 'client'
          : keyTypeCd === 'CG'
          ? 'group'
          : keyTypeCd === 'TYPEPROV'
          ? 'provider'
          : 'plan'
      );
    }
  }, []);
  React.useEffect(() => {
    if (hasHydratedFromExistingContactsRef.current) {
      return;
    }
    if (
      existingContactDetails?.length > 0 &&
      !contactDetails?.length
    ) {
      if (
        existingContactDetails?.filter((x) => {
          return (
            x?.contactTypeCd?.toLowerCase() ===
            contactTypeDropDown[0]?.contactTypeCd?.toLowerCase()
          );
        })?.length > 0
      ) {
        const newObj = existingContactDetails?.filter((x) => {
          return (
            x?.contactTypeCd?.toLowerCase() ===
            contactTypeDropDown[0]?.contactTypeCd?.toLowerCase()
          );
        })[0];
        const safeCd = !contactTypeDropDown?.length
          ? newObj.contactTypeCd || '-1'
          : isContactTypeInDropdown(
              newObj.contactTypeCd,
              contactTypeDropDown
            )
          ? newObj.contactTypeCd
          : '-1';
        const synced = { ...newObj, contactTypeCd: safeCd };
        setContactValues({
          ...synced,
          corrLinkId: synced.corrLinkId ?? null,
        });
        const hydratedValues = {
          contactTypeCd: synced.contactTypeCd || '-1',
          contactSeqNum: synced.contactSeqNum,
          key: synced.key ?? keyId,
          keyTypeCd: synced.keyTypeCd || 'CGP',
          contactName: synced.contactName || '',
          corpName: synced.corpName || '',
          addrLine1: synced.addrLine1 || '',
          addrLine2: synced.addrLine2 || '',
          addrLine3: synced.addrLine3 || '',
          city: synced.city || '',
          stateCd: synced.stateCd || '',
          zip: synced.zip || '',
          zip4: synced.zip4 || '',
          phoneNum: synced.phoneNum || '',
          phoneExtension: synced.phoneExtension || '',
          faxNum: synced.faxNum || '',
          email: synced.email || '',
          corrLinkId: synced.corrLinkId ?? null,
        };
        setValues(hydratedValues);
        dispatch(saveContactData({ ...synced, corrLinkId: synced.corrLinkId ?? null }));
        setOriginalContactBaseline(hydratedValues);
        notifyContactDirty(false);
        if (synced?.corrLinkId) {
          handleExistingCommentList([{ corrLinkId: synced?.corrLinkId }]).then(
            (res) => {
              setCcCommentsExist(res.ccCommentsExist);
            }
          );
        }
        hasHydratedFromExistingContactsRef.current = true;
      } else {
        const newObj = existingContactDetails[0];
        const safeCd = !contactTypeDropDown?.length
          ? newObj.contactTypeCd || '-1'
          : isContactTypeInDropdown(
              newObj.contactTypeCd,
              contactTypeDropDown
            )
          ? newObj.contactTypeCd
          : '-1';
        const synced = { ...newObj, contactTypeCd: safeCd };
        setContactValues({
          ...synced,
          corrLinkId: synced.corrLinkId ?? null,
        });
        const hydratedValues = {
          contactTypeCd: synced.contactTypeCd || '-1',
          contactSeqNum: synced.contactSeqNum,
          key: synced.key ?? keyId,
          keyTypeCd: synced.keyTypeCd || 'CGP',
          contactName: synced.contactName || '',
          corpName: synced.corpName || '',
          addrLine1: synced.addrLine1 || '',
          addrLine2: synced.addrLine2 || '',
          addrLine3: synced.addrLine3 || '',
          city: synced.city || '',
          stateCd: synced.stateCd || '',
          zip: synced.zip || '',
          zip4: synced.zip4 || '',
          phoneNum: synced.phoneNum || '',
          phoneExtension: synced.phoneExtension || '',
          faxNum: synced.faxNum || '',
          email: synced.email || '',
          corrLinkId: synced.corrLinkId ?? null,
        };
        setValues(hydratedValues);
        dispatch(saveContactData({ ...synced, corrLinkId: synced.corrLinkId ?? null }));
        setOriginalContactBaseline(hydratedValues);
        notifyContactDirty(false);
        if (synced?.corrLinkId) {
          handleExistingCommentList([{ corrLinkId: synced?.corrLinkId }]).then(
            (res) => {
              setCcCommentsExist(res.ccCommentsExist);
            }
          );
        }
        hasHydratedFromExistingContactsRef.current = true;
      }
    }
  }, [existingContactDetails, contactDetails]);

  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({
      CONTACT_SEQ_NUM: values?.contactSeqNum,
    });
  };

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const isContactTypeEnabledByMaintainRole = !checkActionAccessByRole(
    process.env.REACT_APP_MAINTAIN_CHECK_DISABLE_ROLE,
    kcRoles
  );
  useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  return (
    <div>
      <Dialog
        open={open}
        onClose={(reason) => {
          if (reason === 'backdropClick' && reason === 'escapeKeyDown') {
            handleClose();
          }
        }}
        data-testid='close-copy-contact-popup'
        maxWidth='md'
        className='inbuilt-dialog dialogPanel custom-check dialog-600'
        PaperComponent={PaperComponent}
        aria-labelledby='draggable-dialog-title'
      >
        <DialogTitle
          className='copy-contact-title'
          style={{ cursor: 'move' }}
          id='draggable-dialog-title'
        >
          <div className='float-left dialog-heading-txt mt-1'>
            Copy Contact from...
          </div>

          <div
            className='close-popup-icon float-right'
            role='button'
            onClick={handleClose}
            tabIndex={0}
          >
            <img alt='' src={cancelIcon} />
          </div>
          <div className='clearfix' />
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <CopyContact
              filterId={keyId}
              setSelectedContact={setSelectedContact}
              entityType={entityType || 'CGP'}
              contactType={contactType}
              defaultData={defaultPlanContactData}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className='btn-wrapper mb-2'>
            <div className='float-right hide-on-print'>
              <Button
                className='btn btn-success btn-search'
                data-testid='reset-contact-detail'
                onClick={setContactIfNotEmpty}
              >
                <SVGComponent iconName='Icon_awesome-check-circle' />
                Ok
              </Button>
              <Button
                data-testid='copy-contact-close'
                className='btn btn-cancel btn-primary'
                onClick={handleClose}
              >
                <SVGComponent iconName='Icon-cancel' />
                Cancel
              </Button>
            </div>
            <div className='clearfix' />
          </div>
        </DialogActions>
      </Dialog>
      <div className='panel-header'>
        <div className='d-flex align-items-center justify-content-end th-icon-group mt-2'>
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='history-tooltip'>View History</Tooltip>}
            aria-label='View History'
          >
            <div
              className='th-icon ic-history'
              role='button'
              tabIndex='0'
              onClick={() => handleViewHistory()}
            >
              {' '}
              <span className='ic-title'> History </span>
            </div>
          </OverlayTrigger>
          {/* {
          keyTypeCd !== 'CLIENT' ||
          checkActionAccessByRole(
            process.env.REACT_APP_STATE_ONLY_ROLE,
            kcRoles
          ) ? (
            <Action handleOpen={handleOpen} keyTypeCd={keyTypeCd} />
          ) : null} */}
          <Action handleOpen={handleOpen} keyTypeCd={keyTypeCd} />
        </div>
      </div>
      <div className='tab-body'>
        <form autoComplete='off'>
          <div className='tab-holder'>
            <fieldset className='custom-fieldset'>
              <legend>Contact Information</legend>
              <div className='form-wrapper'>
                <div className='mui-custom-form with-select'>
                  <TextField
                    id='contact_type'
                    label='Contact Type'
                    fullWidth
                    select
                    required
                    className='mandate-fields'
                    placeholder=''
                    inputProps={{ maxlength: 11, id: 'contact_type' }}
                    value={values?.contactTypeCd}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'contactTypeCd');
                    }}
                    disabled={isContactTypeEnabledByMaintainRole
                        ? false
                        : !isEnablebyRole}
                    error={
                      !!showContacttypeErr &&
                      !disableFields
                    }
                    helperText={
                      showContacttypeErr && !disableFields
                        ? constantMessageData.CONTACT_TYPE_REQUIRED
                        : null
                    }
                  >
                    <MenuItem
                      key=''
                      value='-1'
                      className='frr-dropdown-blank-item'
                    />
                    {contactTypeDropDown?.length > 0
                      ? contactTypeDropDown
                          ?.filter((x) => {
                            return x.contactTypeCd;
                          })
                          ?.map((item) => {
                            return (
                              <MenuItem
                                key={item.contactTypeCd}
                                value={item.contactTypeCd}
                                className="frr-logcheck-dropdown-item"
                              >
                                {`${item.contactTypeCd} | ${
                                  item.shortDescr || ''
                                }`}
                              </MenuItem>
                            );
                          })
                      : null}
                  </TextField>
                </div>
                <div className='mui-custom-form input-md'>
                  <fieldset className='custom-fieldset custom-fieldset-43'>
                    <legend>Existing Contacts 3</legend>
                    <div className='form-wrapper'>
                      {existingContactDetails?.length > 0
                        ? existingContactDetails
                            .filter((x) => {
                              return (
                                x.contactTypeCd !== '' &&
                                x.contactTypeCd !== null &&
                                x.contactTypeCd !== '-1'
                              );
                            })
                            .map((item, index) => {
                              return (
                                <h6>
                                  {item.contactTypeCd}{' '}
                                  {existingContactDetails.filter((x) => {
                                    return (
                                      x.contactTypeCd !== '' &&
                                      x.contactTypeCd !== null &&
                                      x.contactTypeCd !== '-1'
                                    );
                                  }).length ===
                                  index + 1
                                    ? null
                                    : ', '}
                                </h6>
                              );
                            })
                        : null}
                    </div>
                  </fieldset>
                </div>
                <div className='line-break-div' />
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='Name'
                    label='Name'
                    className='mandate-fields'
                    data-testid='Name'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxlength: 50, id: 'Name' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required={
                      values.contactTypeCd !== 'PROV1' && !!isEnablebyRole
                    }
                    value={values.contactName}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'contactName');
                    }}
                    helperText={
                      showNameErr &&
                      !disableFields &&
                      values.contactTypeCd !== 'PROV1'
                        ? constantMessageData.NAME_REQUIRED
                        : null
                    }
                    error={
                      showNameErr &&
                      !disableFields &&
                      values.contactTypeCd !== 'PROV1'
                        ? constantMessageData.NAME_REQUIRED
                        : null
                    }
                    disabled={
                      values.contactTypeCd === 'PROV1' || !isEnablebyRole
                    }
                    tooltipContent={values.contactName}
                    tooltipTriggerLength={36}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='corporation_name'
                    label='Corporation Name'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxlength: 50 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={values.corpName}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'corpName');
                    }}
                    disabled={
                      values.contactTypeCd === 'PROV1' || !isEnablebyRole
                    }
                    tooltipContent={values.corpName}
                    tooltipTriggerLength={36}
                  />
                </div>
                <div className='line-break-div' />
                <div className='mui-custom-form input-md'>
                  <TooltipTextField
                    id='Address Line'
                    label='Address Line 1'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxlength: 50 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    className='mandate-fields'
                    required
                    value={values.addrLine1}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'addrLine1');
                    }}
                    helperText={
                      showAddrErr &&
                      !disableFields &&
                      values.contactTypeCd !== 'PROV1'
                        ? constantMessageData.ADDRESS_LINE1_REQUIRED
                        : null
                    }
                    error={
                      showAddrErr &&
                      !disableFields &&
                      values.contactTypeCd !== 'PROV1'
                        ? constantMessageData.ADDRESS_LINE1_REQUIRED
                        : null
                    }
                    disabled={
                      values.contactTypeCd === 'PROV1' || !isEnablebyRole
                    }
                    tooltipContent={values.addrLine1}
                    tooltipTriggerLength={36}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TooltipTextField
                    id='address2'
                    label='Address Line 2'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxlength: 50 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={values.addrLine2}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'addrLine2');
                    }}
                    disabled={
                      values.contactTypeCd === 'PROV1' || !isEnablebyRole
                    }
                    tooltipContent={values.addrLine2}
                    tooltipTriggerLength={36}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TooltipTextField
                    id='address3'
                    label='Address Line 3+'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxlength: 50 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={values.addrLine3}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'addrLine3');
                    }}
                    disabled={
                      values.contactTypeCd === 'PROV1' || !isEnablebyRole
                    }
                    tooltipContent={values.addrLine3}
                    tooltipTriggerLength={36}
                  />
                </div>
                <div className='line-break-div' />
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='city'
                    label='City'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxlength: 30 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    className='mandate-fields'
                    required
                    value={values.city}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'city');
                    }}
                    helperText={
                      showCityErr &&
                      !disableFields &&
                      values.contactTypeCd !== 'PROV1'
                        ? constantMessageData.CITY_REQUIRED
                        : null
                    }
                    error={
                      showCityErr &&
                      !disableFields &&
                      values.contactTypeCd !== 'PROV1'
                        ? constantMessageData.CITY_REQUIRED
                        : null
                    }
                    disabled={
                      values.contactTypeCd === 'PROV1' || !isEnablebyRole
                    }
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='state'
                    label='State'
                    fullWidth
                    placeholder=''
                    className='mandate-fields'
                    required
                    inputProps={{ maxlength: 2 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={values.stateCd}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'stateCd');
                    }}
                    helperText={
                      showStateErr &&
                      !disableFields &&
                      values.contactTypeCd !== 'PROV1'
                        ? constantMessageData.STATE_REQUIRED
                        : null
                    }
                    error={
                      showStateErr &&
                      !disableFields &&
                      values.contactTypeCd !== 'PROV1'
                        ? constantMessageData.STATE_REQUIRED
                        : null
                    }
                    disabled={
                      values.contactTypeCd === 'PROV1' || !isEnablebyRole
                    }
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <div className='row'>
                    <div className='col-md-7'>
                      <TextField
                        id='Zip'
                        label='Zip'
                        fullWidth
                        className='mandate-fields'
                        required
                        placeholder=''
                        inputProps={{ maxlength: 5 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={values.zip}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'zip');
                        }}
                        helperText={
                          showZipErr &&
                          !disableFields &&
                          values.contactTypeCd !== 'PROV1'
                            ? constantMessageData.ZIP_REQUIRED
                            : null
                        }
                        error={
                          showZipErr &&
                          !disableFields &&
                          values.contactTypeCd !== 'PROV1'
                            ? constantMessageData.ZIP_REQUIRED
                            : null
                        }
                        disabled={
                          values.contactTypeCd === 'PROV1' || !isEnablebyRole
                        }
                      />
                    </div>
                    <div className='col-md-5 pl-0'>
                      <TextField
                        id='Zip+4'
                        label='Zip+4'
                        fullWidth
                        placeholder=''
                        inputProps={{ maxlength: 4 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={values.zip4}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'zip4');
                        }}
                        disabled={
                          values.contactTypeCd === 'PROV1' || !isEnablebyRole
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className='line-break-div' />
                <div className='mui-custom-form input-md'>
                  <div className='row'>
                    <div className='col-md-7'>
                      <TextField
                        id='Phone Number'
                        label='Phone Number'
                        fullWidth
                        required
                        className='mandate-fields'
                        placeholder=''
                        inputProps={{ maxlength: 14 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={values.phoneNum}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'phoneNum');
                        }}
                        helperText={
                          showPhoneErr &&
                          !disableFields &&
                          values.contactTypeCd !== 'PROV1'
                            ? constantMessageData.PHONE_REQUIRED
                            : null
                        }
                        error={
                          showPhoneErr &&
                          !disableFields &&
                          values.contactTypeCd !== 'PROV1'
                            ? constantMessageData.PHONE_REQUIRED
                            : null
                        }
                        disabled={
                          values.contactTypeCd === 'PROV1' || !isEnablebyRole
                        }
                      />
                    </div>
                    <div className='col-md-5 pl-0'>
                      <TextField
                        id='Extension'
                        label='Extension'
                        fullWidth
                        placeholder=''
                        inputProps={{ maxlength: 6 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={values.phoneExtension}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'phoneExtension');
                        }}
                        disabled={
                          values.contactTypeCd === 'PROV1' || !isEnablebyRole
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='Fax Number'
                    label='Fax Number'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxlength: 10 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={values.faxNum || ''}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'faxNum');
                    }}
                    helperText={showFaxErr && !disableFields ?constantMessageData.FAX_REQUIRED:null}
                    error={
                      showFaxErr &&
                      !disableFields 
                     
                        ?constantMessageData.FAX_REQUIRED
                        : null
                    }
                    disabled={!isEnablebyRole}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TooltipTextField
                    id='Email Address'
                    label='Email Address'
                    fullWidth
                    type='email'
                    placeholder=''
                    inputProps={{ maxlength: 50 }}
                    value={values.email}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'email');
                    }}
                    helperText={
                      showEmailErr && !disableFields
                        ? constantMessageData.EMAIL_INVALID
                        : null
                    }
                    error={
                      showEmailErr && !disableFields
                        ? constantMessageData.EMAIL_INVALID
                        : null
                    }
                    tooltipContent={values.email}
                    tooltipTriggerLength={36}
                    disabled={!isEnablebyRole}
                  />
                </div>
              </div>

              <div className='col-6'>
                <div className='mui-custom-form input-md'>
                  <div className='comment-sec mt-26'>
                    Comments{' '}
                    {parseInt(ccCommentsExist, [0, 1]) === 1 ? (
                      <img
                        role='button'
                        onClick={() => {
                          setShowComments(true);
                        }}
                        alt='comment'
                        tabIndex={'0'}
                        onKeyDown={(e) => {
                          // Handle Enter and Space key events
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); // Prevents the default space scrolling behavior
                            setShowComments(true);
                          }
                        }}
                        src={CommentVisibleIcon}
                      />
                    ) : (
                      <img
                        role='button'
                        onClick={() => {
                          setShowComments(true);
                        }}
                        tabIndex={'0'}
                        onKeyDown={(e) => {
                          // Handle Enter and Space key events
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); // Prevents the default space scrolling behavior
                            setShowComments(true);
                          }
                        }}
                        alt='comment'
                        src={CommentIcon}
                      />
                    )}
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </form>
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName='CONTACT'
          corrLinkId={
            allContactData?.corrLinkId || values?.corrLinkId || -1
          }
          rowGridPrimaryKey={allContactData?.contactSeqNum}
        />
      ) : null}
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName='CONTACT'
          keyValue={keyValue}
        />
      )}
    </div>
  );
};

const Action = (props) => {
  const { handleOpen, keyTypeCd } = props;
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);
  return (
    <div className='panel-header action-block'>
      <div className='float-right th-icon-group mt-1 hide-on-print'>
        <Dropdown
          data-testid='actionDropdown'
          key='actionDropdown'
          className='icon-dropdown-container'
        >
          <Dropdown.Toggle
            className='icon-dropdown'
            aria-label='Action Dropdown Toggle'
          >
            <SVGComponent iconName='Export-icon' />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              key='actionDropdown2'
              data-testid='actionDropdown2'
              role='button'
              tabIndex='0'
              onClick={handleOpen}
              disabled={!isEnablebyRole}
            >
              Copy Contact from...
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};
export default PlanContactForm;